<div class="location-settings">
  <h3>LOCATION SETTINGS<span *ngIf="store"> · {{ store.storeName }}</span></h3>
  <p class="hint" *ngIf="store">
    Sales tax for {{ store.storeName }} is calculated from this rate when that location processes the sale. It applies to taxable items and custom work after discounts. Postage is not taxed. Leave the rate at 0 to use the TAX amount entered on the order. Switch the location in the header to set another store's rate.
  </p>
  <p class="hint" *ngIf="!store">Select a location in the header to set its sales tax rate.</p>

  <div class="store-card" *ngIf="store">
    <mat-form-field>
      <mat-label>SALES TAX %</mat-label>
      <input matInput type="number" min="0" max="100" step="0.01" [(ngModel)]="store.salesTaxRate">
      <span matSuffix>&nbsp;%</span>
      <mat-hint *ngIf="suggestedRate(store)">About {{ suggestedRate(store) }}%. Change it here if the local rate changes.</mat-hint>
    </mat-form-field>
    <button mat-raised-button type="button" [disabled]="saving" (click)="save()">
      SAVE
    </button>
  </div>
</div>
